import { apiClient } from '@app/lib'
import { type SugarEnrollmentInput, type SugarSaveEnrollmentResponse } from '@app/types'
import { useMutation } from '@tanstack/react-query'

export const useSaveEnrollment = () =>
  useMutation({
    mutationKey: ['saveEnrollment'],
    mutationFn: async (input: SugarEnrollmentInput) => {
      const { data } = await apiClient.post<SugarSaveEnrollmentResponse>('/api/enrollments', input)

      return data
    }
  })
